
export default {
  // 公共页面
  common: {
    title: "Trafik Mağazası",
    pull_refresh: 'Yenilemek için aşağı çekin',
    release_refresh: 'Yenilemek için bırakın',
    refresh_loading: 'Yenileniyor...',
    footer_text: 'Hizmetler Ucloudlink (NASDAQ: UCL) tarafından sağlanmaktadır'
  },
  home: {
    input_placeholder: 'Ülke/Bölge ara',
    my_flow: 'Veriğim',
    charge_code: 'Kupon Kodu',
    coupons:'Kuponlar',
    local_package: 'Yerel trafik',
    more: 'Daha fazla',
    popular_destination: 'Ülke/Bölge',
    buy_now: 'Şimdi al',
    package_useing: 'Aktif',
    unused: 'Pasif',
    download_app: 'Uygulamayı indir',
    enter_the_mall_list: 'Mağaza listesine girin',
    no_data: 'Veri yok',
    no_data_available: "Veri mevcut değil",
    copy_success: 'Başarıyla kopyalandı',
    copy_fail: 'Kopyalama başarısız oldu',
    meritsTitle: 'Avantajları Nelerdir?',
    merits1: 'SIM Gerektirmez & Aylık Ücret Yok',
    merits2: 'En iyi 2-3 operatör ile entegre, otomatik ağ geçişi',
    go_buy: 'Satın al',
    instant_savings: 'Tasarruf Et',
    expires_in: 'Süresi doluyor',
    download_app_tips: "Uygulamayı indir, daha fazla fırsat ve deneyim kazanın"
  },
  packages: {
    sub_title: {
      us: 'Guam ve Saipan hariç',
      it: 'Vatikan ve San Marino için geçerli',
      va: 'İtalya ve San Marino için geçerli',
      sm: 'İtalya ve Vatikan için geçerli',
      ma: 'Batı Sahra için geçerli',
      eh: 'Fas için geçerli',
      ch: 'Liechtenstein için geçerli',
      li: 'İsviçre için geçerli',
      fr: 'Monako için geçerli',
      mc: 'Fransa için geçerli',
      fi: 'Åland Adaları için geçerli',
      ax: 'Finlandiya için geçerli',
      gu: 'Saipan için geçerli',
      mp: 'Guam için geçerli'
    },
    unlimited_packages: 'Sınırsız veri paketi',
    normal_packages: 'Standart Paket',
    multi_region_packages: 'Çok bölgeli',
    regional_data: 'Bölgesel Veri',
    high_speed_text: 'Yüksek hızlı trafik',
    infiniteFlow:'Sınırsız Veriler',
    unLimitData: 'Sınırsız',
    high_speed_text_year: 'Aylık yüksek hızlı trafik',
    package_list: 'Paket listesi',
    special_offer: 'İndirimler',
    first_month: '1.Ay',
    periodUnit: {
      day: 'Gün',
      month: 'Ay',
      hour: 'Saat',
      year: 'Yıl',
    },
    periodUnits: {
      day: 'Gün',
      month: 'Ay',
      hour: 'Saat',
      year: 'Yıl',
    },
    periodUnitSimp: {
      day: 'Gün',
      month: 'Ay',
      hour: 'Saat',
      year: 'Yıl'
    },
    periodUnitMonthly:'Aylık',
    periodUnitsSimp: {
      day: 'Gün',
      month: 'Ay',
      hour: 'Saat',
      year: 'Yıl'
    },
    unlimited_good_name: {
      day: 'Günlük Paket',
      month: 'Aylık Paketi',
      year: 'Yıllık  Paketi'
    },
    continuousMonth : "Sürekli aylar",
    continuousDay : "Sürekli günler",
    continuousYear:"Sürekli Yıllar",
    day_invalid: 'Aynı gün sona eriyor',
    month_invalid: 'Bu ay sona eriyor',
    immediate_valid: 'Hemen yürürlüğe girer',
    tomorrow_day_valid: 'Ertesi günden itibaren yürürlüğe girer',
    tomorrow_month_valid: 'Gelecek aydan itibaren yürürlüğe girer',
    detail: {
      cell_flow: 'Trafik',
      cell_period: 'Geçerlilik süresi',
      buy_quantity: 'Tutar',
      use_area: 'Uygulama bölgesi',
      use_intro: 'Kullanım koşulları',
      buy_btn: 'Sipariş ver',
      pay: 'Öde',
      buy_tips: '%@packageName paketinizi kullanıyorsunuz. Bu paketi satın almak istiyor musunuz?',
      haveOrderTips: "Ödeme bekleyen sipariş oluşturuldu. Onayla'yı tıklayın ve Veri Sayfam'a gidin！"
    },
    confirm: {
      title: 'Sipariş onayı',
      real_pay_amount: 'Ödenen tutar',
      online_payment: 'Online ödeme',
      create_order_error: 'Sipariş oluşturma başarısız oldu'
    }
  },
  pay: {
    result: {
      loading_order_status: 'Sipariş durumu alınıyor...',
      buy_success: 'Sipariş başarılı',
      buy_pending: 'Ödeme onay bekleniyor',
      buy_pending_tip: 'Ödeme sonucu onaylanıyor, eğer 10 dakika sonra hala hesaba geçmediyse lütfen müşteri hizmetleri ile iletişime geçin.',
      get_payment_info_fail: 'Ödeme bilgisi alınamadı',
      cell_package: 'Paket',
      cell_buy_amount: 'Ara toplam',
      cell_real_amount: 'Ödenen tutar',
      go_to_order_btn: 'Paketime Git',
      back_home: 'Ana sayfaya dön',
      back_mall: 'Alışveriş merkezine geri dön',
      ordersn_empty: 'Sipariş SN\'si boş olamaz',
      order_search_error: 'İlgili sipariş bilgisi bulunamadı',
      goodsName:'Ürün adı'
    },
    fail: {
      payment_fail: 'Ödeme başarısız',
      back_home: 'Ana sayfaya dön'
    }
  },
  CountryGroup: {
    title: "Ülke/Bölge",
    placeholder: "Ülke/Bölge ara",
    clear: "Temizle",
    history: "Geçmiş veriler"
  },
  PromotionCode: {
    verification: {
      title: 'Dolum kartı',
      minititle:'Dolum kodu',
      input: 'Lütfen dolum kodunu girin',
      explain: 'Açıklama: Tarama ikonuna tıklayarak dolum kartının QR kodunu tarayın ya da elle girin (büyük/küçük harf duyarlıdır)',
      submit: 'Gönder',
      exchange: 'Takas',
      cancel: 'İptal',
      Inquiry: "Takası onayla",
      ErrorCode: 'Dolum kodu hatalı',
    },
    recharge_success: {
      package: 'Trafik paketi',
      content: 'Takas başarılı',
      back: 'Mağazaya dön',
      view_packets: 'Trafik miktarımı görüntüle'
    }
  },
  order: {
    state: {
      inUse: 'Kullanımda',
      isFirst: 'Öncelik verildi',
      toFirst: 'Öncelik',
      inactive: 'Aktif değil'
    },
    periodUnits: {
      minute: 'Dakika',
      hour: 'Saat',
      day: 'Gün',
      month: 'Ay',
    },
    useIntro: {
      tip1: 'Zevk Paketi, Standart Paketten daha yüksek önceliğe sahiptir.',
      tip2: 'Aynı tip trafik paketleri genellikle ilk sipariş edilen ilk kullanılan prensibini takip eder, ancak tek yer paketi çok yer paketinden önce kullanılır.',
      tip3: 'Aynı tip trafik paketlerinin kullanım önceliğini manuel olarak ayarlayabilirsiniz.'
    },
    myFlow: 'Veriğim',
    remainingFlow: 'Kalan trafik',
    remainingTime: 'Kalan süre',
    remainingHighFlow: 'Kalan yüksek hız',
    validPeriod: 'Geçerlilik süresi',
    noneFlow: 'Geçerli trafik paketi yok',
    noneFlowTip: 'Kaliteli ağdan yararlanmak için trafik paketi satın alın',
    buyPackFlow: 'Paket satın al',
    checkInvalidFlow: 'Geçersiz trafik paketlerini görüntüle',
    orderList: {
      "title": "siparişlerim",
      "amount_paid": "Toplam",
      "device": "Sahip olunan cihaz",
      "order_details": "Sipariş ayrıntıları",
      "total_amont": "Ara toplam",
      "orderSN": "Sipariş no.",
      "createTime": "Yaratılış zamanı",
      "cancelTime": "Kapalı zaman",
      "payTime": "Sipariş zamanı",
      "unsubTime": "İptal edilen zaman",
      "payMethod": "Ödeme yöntemi",
      "thirdSN": "İşlem numarası",
      "delete": "Silmek",
      "cancel": "Siparişi İptal Et",
      "unsub": "Geri ödemek",
      "goto_cancel": "Siparişi iptal etmek istiyor musunuz?",
      "goto_unsubscribe": "Sipariş aboneliğinden çıkmak istiyor musunuz?",
      "delete_Tips": "Sipariş silindikten sonra tekrar devam edilemez, dolayısıyla servis sonrası sorunlarınız çözülemez.Silmek istediğinizden emin misiniz?",
      "status_success": "Tamamlanmış",
      "status_pending": "ödenmemiş",
      "status_cancel": "Kapalı",
      "status_unsub": "İptal edildi",
      "payMethod_stripe": "Kredi Kartı"
    },
  },
  registerlogin: { 
    create_account_tip: 'Bir hesap oluşturun, özel bir deneyim başlatın',
    select_country_tip:"Cihaz Ülke/Bölgeyi Kullanın",
    email_name: "Posta",
    phone_name: "Telefon",
    email_address: "E-posta adresi",
    password: "şifre",
    country: "ülke",
    select_country: "Bir Ülke Seçin",
    cancel: "İptal etmek",
    confirm: "Elbette",
    please_enter: "Lütfen 6-20 karakter girin (harf, sayılar veya semboller kombinasyonu)",
    select_country_tips: "Ülke seçimi yerel paketleri görüntülemek içindir. Kayıttan sonra değiştirilemez. Lütfen onaylayın!",
    global_roaming: "Uluslararası Etki Alanı Kodu",
    phone_number: "telefon numarası",
    agree: "kabul etmek",
    user_agreement: "Kullanıcı sözleşmesi",
    and: "Ve",
    privacy_policy: "Gizlilik Politikası",
    register_login: "Kaydolun veya oturum açın",
    login_error: "Oturum açma sayısı çok sık, lütfen daha sonra tekrar deneyin!",
    register_error: "Kayıt sayısı çok sık, lütfen daha sonra tekrar deneyin!",
    forgot_pwd: "Şifreyi unutun",
    app_tips: "Daha fazla özelliğe erişmek için indirdikten sonra bu hesapla uygulamaya giriş yapın.",
    download_app: "Uygulamayı indirmeye git",
    rememberPwd: "Şifreyi hatırla",
    third_login: 'Şununla devam et',
    agreement_tips: "Lütfen Kullanıcı Sözleşmesi ve Gizlilik Politikası kutusunu işaretleyin",
    selectCountry_tips: "Lütfen kayıtlı ülkenin aşağıdaki ödeme yöntemlerini ve para birimlerini doğrudan etkileyeceğini unutmayın; lütfen ihtiyacınıza göre seçim yapın.",
    login_error_cancel: "Kullanıcı oturum açmayı iptal etti",
    login_error_auth: "Tarayıcı ayarlarından açılır pencerelere izin verin",
    device_tips: "Cihaz aktifleşme bekliyor. 24 saat içinde işlem yapılır."
  },
  forgotPwd: {
    forgot_pwd: "Şifreyi unutun",
    email_address: "E-posta adresi",
    next: "Sonraki",
    email_has_been_sent: "%@email için bir e-posta gönderdik. Lütfen bağlantıyı tıklayın ve şifrenizi almak için adımları izleyin.",
    have_retrieved_it: "Buldum",
    unable_to_receive_email: "E-postayı alamıyor musunuz? Lütfen spam ve silinmiş posta dizininiz altında %@email ile e-posta olup olmadığını kontrol edin",
    or: "veya",
    resend: "Yeniden ortaya çıkarmak",
    global_roaming: "Uluslararası Etki Alanı Kodu",
    phone_number: "telefon numarası",
    verification_code_has_been_sent: "Doğrulama kodunu şu adrese gönderdik:",
    verification_code: "Doğrulama Kodu",
    no_verification_code_received: "Doğrulama kodunu almadınız mı?",
    please_enter: "Lütfen 6-20 karakter girin (harf, sayılar veya semboller kombinasyonu)",
    reset_password: "Parolayı sıfırla",
    reset_successful: "Başarılı bir şekilde sıfırlayın"
  },
  coupons: {
    coupons_name: "Kuponlar",
    no_coupons: "Henüz kupon yok",
    no_data: "Henüz veri yok",
    applicable_to_the_following: "Kuponlar aşağıdaki veri paketi için uygundur"
  },
  digital: {
    title: "Cihaz SN",
    purchased: "Alımlarım",
    viewAll: "Daha",
    skinStore: "Ürün mağazası",
    completed: "Satın alınmış",
    goBuy: "Satın almak",
    order: {
        title: "Satın alınan siparişler"
    },
    detail: {
        describe: "Tanım"
    }
  },
  viewPL: {
    other: 'öteki'
  },
  invalidFlow: {
    stateName: 'Durum',
    state: {
      NOT_ACTIVATED: "Aktif değil",
      IN_USING: "Kullanılabilir",
      USE_END: "Tükenmiş",
      EXPIRE: "Süresi dolmuş",
      TRANSFER: "Transfer edilmiş",
      UNSUBSCRIBE: "Abonelikten çık",
      VALID: "Geçerli",
      INVALID: "Geçersiz",
      EXCHANGE_POINTS: "Puan takası"
    },
    noneFlow: 'Geçersiz trafik paketi yok',
    pageName: 'Geçersiz trafik paketleri'
  },
  flowDetail: {
    title: 'Trafik detayları',
    flow: 'Trafik',
    validTime: 'Etkinleşme zamanı',
    invalidTime: 'Geçersiz olma zamanı',
    coverage: 'Uygulama bölgesi',
    useIntro: 'Kullanım koşulları',
    purchaseTime: 'Satın alma zamanı',
    subtotal: 'Ödeme miktarı',
    status: 'Durum',
    cancel: 'Abonelikten çık',
    buyAgain: 'Tekrar satın al',
    validity: 'Geçerlilik süresi',
    tip: 'İpucu',
    cancelTip: 'Trafik paketinden çıkmak istiyor musunuz?',
    dataLeft: 'Kalan'
  },
  netError: {
    try_again: 'Tekrar dene',
    net_error: 'Ağ yok',
    try_again_desc: 'Lütfen ağ ayarlarını kontrol edin ve tekrar deneyin'
  },
  loadFail: {
    try_again: 'Tekrar dene',
    load_fail: 'Yükleme başarısız oldu',
    load_fail_desc: 'Veri yüklenemedi, lütfen tekrar deneyin',
    IMEI_Not_Exist: 'IMEI mevcut değil',
    Project_Not_Exist:'Bir hata oluştu, lütfen müşteri hizmetleri ile iletişime geçin (01)',
    commonError:'Bir hata oluştu, lütfen müşteri hizmetleri ile iletişime geçin'
  },
  settlement_Easy_and_convenient:"Kolay ve rahat",
  settlement_Great_deal:"Büyük anlaşma",
  settlement_Safe_and_secure:"Güvenli ve Güvenli",
  settlement_Autopay_service_regulation:"Otomatik hizmet düzenlemesi",
  settlement_Read:"Okumak",
  settlement_No_coupon:"Mevcut kupon yok",
  settlement_Subtotal:"Alt kat",
  settlement_Coupon:"Kupon",
  settlement_TOTAL:"Toplam",
  settlement_promotion_tip:"Promosyon teklifi herhangi bir kuponla birlikte kullanılamaz",
  settlement_coupon_tip:"Kupon, diğer promosyon teklifleriyle birlikte kullanılamaz",
  member_myFlow_noList:"Veri Yok",
  detail_se_content:"Güvenli, kolay ve kullanışlı bir yol. İstediğiniz zaman abone olabilirsiniz",
  Enter_Promo_code:"Promosyon kodu",
  Enter_Promo_Coupon:"Kuponlar",
  settlement_Not_used_coupon:"Kupon kullanılmıyor",
  settlement_Available_coupon:"Mevcut",
  settlement_Unavailable_coupon:"Müsait olmayan",
  please_Enter_Promo_code:"Lütfen Promosyon Kodunu girin",
  please_Select_Coupon_use:　"Lütfen kullanmak istediğiniz kuponu seçin.",
  Buy_Now:"Şimdi al",
  Dont_Use_Any:"Hiç kullanma",
  flowDetail_unsubscribe: "Abartmak",
  flowDetail_unsubscribed: "Abartılmamış",
  flowDetail_isCancelPackage: "Bu paketin aboneliğinden çıkın mı?",
  flowDetail_confirmAgreementUnsubscribe : "Abonelikten çıktıktan sonra çok şey alamazsınız. Abone olmak istediğinden emin misiniz?",
  flowDetail_cancel: "İptal etmek",
  flowDetail_cancelSuccess: "Başarılı bir şekilde abonelikten çıkın",
  packages_detail_promotion:"Terfi",
  orderTips:{
        "iDay" : "gün",
        "iDays" : "günler",
        "iMonth" : "ay",
        "iMonths" : "aylar",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol İlk satın almanızda, Ödeme %@money/%@periodSymbol, İstediğiniz zaman abone olabilirsiniz",
        'Monthly_discount':"Kaydet %@saveMoney her %@period! İstediğiniz zaman abone olabilirsiniz ",
        'Ordinary_monthly_package':"Güvenli, kolay ve kullanışlı bir yol. İstediğiniz zaman abone olabilirsiniz",
        "AlreadyPurchased":'Şu anda yalnızca bir veri paketine abone olabileceğiniz için üzgünüm. Lütfen “%@” den abone olun ve daha sonra sona erdikten sonra istediğiniz herhangi bir pakete abone olun.',
        "Contract_recommendation_First":'<label>Otomatik hizmet ile, ilk satın almanızda, sadece ödeyin</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">İstediğiniz zaman abone olabilirsiniz'
        +'<a class="btn">Abone ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Otomatik hizmet ile sadece ödeme</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">İstediğiniz zaman abone olabilirsiniz'
        +'<a class="btn">Abone ></a></p>',
        "Contract_recommendation_General":"<label>Otomatik hizmet ile</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Güvenli, kolay ve kullanışlı bir yol. İstediğiniz zaman abone olabilirsiniz'
        +'<a href="javascript:;" class="btn">Abone ></a></p>',
        'BanlanceDoubleCheck':'Denge ile ödeme yapmak istediğinden emin misiniz?',
    },
    feedback: {
      title: "geri bildirim",
      placeholder: "Lütfen ziyaret etmek istediğiniz ülkeye veya diğer soruları girin; en kısa sürede ihtiyaçlarınızı karşılayacağız!",
      submit: "Gönder",
      submit_success: "Başarıyla gönderildi",
      other_opinions: "Diğer görüşler"
    },
    view_country_input: 'Lütfen hesabınızı girin',
    select_package: {
      title: "Veri Seçin",
      allPackage: 'Tüm Veriler',
      type: "Tip",
      flow: "Veri",
      month_package: "Aylık Plan",
      flow_package: "Veri Paketi",
      time: "Süre",
      period: "Döngü",
      auto_debit: "Otomatik Ödeme Bilgi",
      auto_subscribe: "Otom. Yenileme",
      detail: "Veri Detayları",
      carrier: "Desteklenen Sağlayıcılar",
      country: "Kapsanan Ülkeler",
      notice: "Alışveriş Kılavuzu"
    }
}
